import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { useCategoriesByType, useConfigRule } from '@app/sdk';
import { ProductOrMerchant } from './ProductOrMerchant';

export function CategorySelector({
  item,
  selectedCategory,
  selectedOuId,
  setSelectedCategory,
  categories,
  setCategories,
  type,
}: {
  item: ProductOrMerchant | undefined;
  selectedCategory: string;
  selectedOuId: string;
  setSelectedCategory: Dispatch<SetStateAction<string>>;
  categories: any[];
  setCategories: Dispatch<SetStateAction<any[]>>;
  type: 'product' | 'merchant';
}) {
  const { data: config } = useConfigRule({ ouId: selectedOuId });
  const { data: productOrMerchantCategories } = useCategoriesByType({ type });
  useEffect(() => {
    if (config && productOrMerchantCategories) {
      const categories = config.map((x) => x.category);
      const uniqueCategories = [...new Set(categories)];
      setCategories(productOrMerchantCategories.filter((x) => uniqueCategories.includes(x.id)));
    }
  }, [config, productOrMerchantCategories, setCategories]);

  return (
    <div className="field">
      <div className="ui labeled right input">
        <div className="ui label">Category</div>
        <div className="ui input">
          <select
            key={(item?.productId || item?.merchantId) + JSON.stringify(categories)}
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}>
            <option key={'select'} value={''}>
              Select...
            </option>
            {categories.map((category) => {
              return (
                <option key={category.id} value={category.id}>
                  {category.name} (id: {category.id})
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );
}
